import { Utility } from '../utility/utility_controller'
import animation_lifecycle_controller from '../animations/lifecycle/animation_lifecycle_controller'
import { showElementInView } from './reveal_state'

const NAV_TRANSITION_TARGET_CLASS = 'lay-nav-transition-in-target'
const SCROLLSLIDER_CONTENT_CLASSNAMES = ['scrollslider-active', 'infinite-scrollslider-active']
const ROW_BACKGROUND_SELECTOR = '.row.has-background > .lay-row-bg-color, .row.has-background > .background-image, .row.has-background > .background-video, .row.has-background > .lay-webgl-slideshow, .row.has-background > .lay-row-canvas-animation:not(.lay-row-canvas-animation-field-zoom), .row.has-background > .lay-row-bg-color-fade, .row > .lay-row-gutter-bg'

export const LOAD_MORE_WRAPPER_SELECTORS = ['.lay-thumbnailgrid-load-more-wrap', '.lay-elementgrid-load-more-wrap', '.lay-productsgrid-load-more-wrap', '.lay-news-load-more-wrap']

export const isOpacityAnimationEnabled = () => {
	const val = layData.misc_options_element_transition_animate_opacity
	return val !== '' && val !== '0' && val !== 0
}

export const shouldApplyTransitionDelay = () => isOpacityAnimationEnabled()

export const getScrollTransitionOffset = () => {
	const rawOffset = Utility.isPhoneSize ? layData.misc_options_scroll_transition_offset_mobile : layData.misc_options_scroll_transition_offset_desktop
	const offset = Number.parseInt(rawOffset, 10)
	return Number.isFinite(offset) ? offset : 0
}

export const getBelowStartBottom = () => window.innerHeight - getScrollTransitionOffset()

export const getObserverOptions = () => ({
	threshold: 0,
	rootMargin: '0px 0px ' + getScrollTransitionOffset() + 'px 0px',
})

const isNavigationTransitionTarget = (element) => {
	return !!(element.classList.contains(NAV_TRANSITION_TARGET_CLASS) || (element.closest && element.closest('.' + NAV_TRANSITION_TARGET_CLASS)))
}

export const hasActiveNavigationTransition = (element) => {
	return !!(
		animation_lifecycle_controller.isNavigationAnimating() ||
		(element &&
		(
			(element.closest && element.closest('.disable-css-transitions')) ||
			(element.querySelector && element.querySelector('.disable-css-transitions')) ||
			isNavigationTransitionTarget(element) ||
			(element.querySelector && element.querySelector('.' + NAV_TRANSITION_TARGET_CLASS))
		))
	)
}

export const showNavigationTransitionTargetIfVisibleAtRest = (element, rootBottom = window.innerHeight) => {
	if (!isNavigationTransitionTarget(element)) {
		return false
	}
	const rect = element.getBoundingClientRect()
	if (rect.width === 0 && rect.height === 0) {
		return false
	}
	if (rect.top < rootBottom && rect.bottom > 0) {
		showElementInView(element)
		return true
	}
	return false
}

export const getScopedSelectorList = (parent, selectors, suffix = '') => selectors.map((selector) => parent + ' ' + selector + suffix).join(',')

const shouldAnimateRowBackgroundsOnScroll = () => {
	const val = layData.misc_options_scroll_transition_animate_row_backgrounds
	return val == null || val === true || val === '1' || val === 1 || val === 'on'
}

export const getScopedRowBackgroundSelector = (parent, suffix = '') => {
	if (!shouldAnimateRowBackgroundsOnScroll()) {
		return ''
	}
	return ROW_BACKGROUND_SELECTOR.split(',').map((selector) => parent + ' ' + selector.trim() + suffix).join(',')
}

const isScrollSliderActiveGlobally = () => {
	// because this function just checks data-id of body, and that data-id changes when opening a project overlay,
	// this should not by accident think that the project overlay has a active scrollslider, when only the underlying page has a active scrollslider
	return window.layscrollslider != undefined && typeof window.layscrollslider.isActiveHere === 'function' && window.layscrollslider.isActiveHere()
}

const isInsideScrollSliderContent = (element) => {
	if (element == null) {
		return false
	}

	const layContentParent = element.closest('.lay-content')
	if (!layContentParent) {
		return false
	}

	if (layContentParent.closest('#lay-project-overlay')) {
		return false
	}

	if (SCROLLSLIDER_CONTENT_CLASSNAMES.some((className) => layContentParent.classList.contains(className))) {
		return true
	}

	if (isScrollSliderActiveGlobally() && layContentParent.matches && layContentParent.matches('body>.lay-content')) {
		return true
	}

	return false
}

export const filterOutScrollSliderElements = (nodeList) => {
	return Array.from(nodeList).filter((element) => {
		const insideScrollSlider = isInsideScrollSliderContent(element)
		return !insideScrollSlider
	})
}

export const isElementVisibleInViewport = (element) => {
	const rect = element.getBoundingClientRect()
	return !(rect.width === 0 && rect.height === 0) && rect.top < window.innerHeight && rect.bottom > 0
}

export const transitionWasDisabledInline = (element) => {
	return element.style.transition === 'none' || element.style.transitionProperty === 'none'
}

export const clearDisabledInlineTransition = (element) => {
	element.style.transition = ''
	element.style.transitionProperty = ''
	element.style.transitionDuration = ''
	element.style.transitionTimingFunction = ''
	if ('transitionBehavior' in element.style) {
		element.style.transitionBehavior = ''
	}
}

export const shouldAnimateElement = (element) => {
	if (window.getComputedStyle(element).display === 'none') {
		return false
	}
	if (element.classList.contains('thumb')) {
		const parentWrap = element.closest('.thumbnail-wrap')
		if (parentWrap) {
			if (parentWrap.classList.contains('hide-loadmore')) {
				return false
			}
			const parentStyle = window.getComputedStyle(parentWrap)
			if (parentStyle.display === 'none') {
				return false
			}
		}
	}
	return true
}

export const isRevealAnimationDisabled = (element) => {
	if (!element || !element.classList) {
		return true
	}
	if (element.classList.contains('no-animation') || element.classList.contains('no-animate-in-on-scroll')) {
		return true
	}
	const parentCol = element.closest && element.closest('.col')
	return !!(parentCol && parentCol !== element && parentCol.classList && (parentCol.classList.contains('no-animation') || parentCol.classList.contains('no-animate-in-on-scroll')))
}

let multiplyWith = 1

export const getTransitionDelayAlt = (el, rect) => {
	if (!isOpacityAnimationEnabled()) {
		return 0
	}
	var top = rect.top
	var autoLayoutRow = el.closest('.row.lay-auto-layout-row')
	if (autoLayoutRow) {
		top = autoLayoutRow.getBoundingClientRect().top
	}
	var v = getDistance(0, 0, rect.left, top)
	let c = v * 0.25
	return parseInt(c * multiplyWith)
}

export const reduceDelay = () => {
	multiplyWith = 0
}

export const makeDelayNormalAgain = () => {
	multiplyWith = 1
}

function getDistance(x1, y1, x2, y2) {
	let y = x2 - x1
	let x = y2 - y1
	return Math.sqrt(x * x + y * y)
}
